import { render } from "./Recaptcha.vue?vue&type=template&id=9bbb7de0"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"

import "./Recaptcha.vue?vue&type=style&index=0&id=9bbb7de0&lang=scss"
script.render = render

export default script